import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ModuleItem from "./module_item";
import { OPTIONS_SELECTOR_DISPLAY_MODES } from "..";
import ModuleCategoryDropdown from "./module_category_dropdown";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const TitleAndLineWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const CategoryTitle = styled.span`
  ${props => props.displayType === 'flat' ? `
    font-size: 16px;
    color: ${props.color ? props.color : `#3DCD58`};
    font-weight: 400;
  `  : `
    font-weight: 700;
    font-size: 18px;
    color: #626469;
    `
  }
`;

const Line = styled.div`
  display: flex;
  flex: 1 1 0px;
  background-color: rgba(151, 151, 151, 0.50);
  height: 1px;
  min-height: 1px;
  max-height: 1px;
  box-sizing: border-box;
  margin-left: 10px;
`;

class ModuleCategory extends React.Component {
  static propTypes = {
    moduleCategory: PropTypes.object,
    isSaving: PropTypes.bool,
    renderProductLink: PropTypes.func,
    mobileBreakpoint: PropTypes.number,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secondaryTextColor: PropTypes.string,
    getLabel: PropTypes.func,
    getAndReplaceLabel: PropTypes.func,
    categoryDisplayMode: PropTypes.number
  };

  renderModuleItems = (moduleItems) => {
    return moduleItems.map((item, idx) => {
      return <ModuleItem
        key={idx}
        displayType={this.props.moduleCategory?.displayType}
        categoryName={this.props.moduleCategory.categoryName}
        moduleItem={item}
        renderProductLink={this.props.renderProductLink}
        mobileBreakpoint={this.props.mobileBreakpoint}
        primaryColor={this.props.primaryColor}
        primaryTextColor={this.props.primaryTextColor}
        secondaryColor={this.props.secondaryColor}
        secondaryTextColor={this.props.secondaryTextColor}
        isSaving={this.props.isSaving}
        getLabel={this.props.getLabel}
        getAndReplaceLabel={this.props.getAndReplaceLabel}
      ></ModuleItem>;
    });
  }

  renderCategory = (moduleItems) => {

    if (this.props.categoryDisplayMode === OPTIONS_SELECTOR_DISPLAY_MODES.DROPDOWN) {
      return (
        <ModuleCategoryDropdown defaultOpenStatus={true}
          title={this.props.moduleCategory.categoryName}
          content={this.renderModuleItems(moduleItems)}
        >
        </ModuleCategoryDropdown>
      );
    }

    return (
      <Container>
        <TitleAndLineWrapper>
          <CategoryTitle displayType={this.props.moduleCategory?.displayType} color={this.props.secondaryColor}>{this.props.moduleCategory.categoryName}</CategoryTitle>
          {this.props.moduleCategory?.displayType === 'flat' && <Line></Line>}
        </TitleAndLineWrapper>
        {this.renderModuleItems(moduleItems)}
      </Container>
    );
  }

  render = () => {
    const moduleItems = this.props.moduleCategory.moduleItems;
    const nbItems = moduleItems.length;

    return nbItems > 0 ? this.renderCategory(moduleItems) : (<></>);
  };
}

export default ModuleCategory;
